import AddCircleIcon from "@mui/icons-material/AddCircle";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import LayersIcon from "@mui/icons-material/Layers";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  CircularProgress,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Fab,
  IconButton,
  InputAdornment,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  type Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  Archive,
  Ban,
  Car,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Clock,
  Download,
  Eye,
  FileText,
  Handshake,
  Monitor,
  MoreVertical,
  Pencil,
  Plus,
  Smartphone,
  User,
  X,
  XCircle,
} from "lucide-react";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorScreen, Loading } from "../../../components";
import { ActionButton } from "../../../components/button-v2/ActionButton";
import { TableActionsMenuContaPagar } from "../../../components/menu-actions/MenuActionsButton";
import { PaginationButton } from "../../../components/PaginattionButton/PaginattionButton";
import { useToastStore } from "../../../stores";
import {
  bordasComponents,
  cellStyle,
  cellStyleDestaque,
  colorPrimary,
  colorSubText,
} from "../../../theme";
import {
  formatCurrencyBRL,
  formatDateFromISOTable,
} from "../../../utils/mask/MaskUtils";
import { UserRole } from "../../../utils/enums/UserRole";
import { DashboardStatCard } from "../components/DashboardStatCard";
import { RevendaInfoDialog } from "../components/RevendaInfoDialog";
import { statusChip } from "../components/statusChip";
import { tipoAnuncioChip } from "../components/tipoAnuncioChip";
import {
  AnuncioAcessoDTO,
  AnuncioApiDTO,
  DashBoardCompany,
  RevendaInfoDetailsDTO,
} from "../dto/CompanyDTO";
import {
  allowCotacao,
  exportAnunciosExcel,
  exportAnunciosPdf,
  fetchAnuncioAcesso,
  fetchAnunciosCompany,
  fetchDashBoardComapny,
  fetchRevendaInfoDetails,
  rejectCotacao,
} from "../repository/ComapnyRepository";






export function AnunciosPage() {
  const isAdmin = sessionStorage.getItem("groupsid") === UserRole.Admin;
  const jaCarregouRef = useRef(false);
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [anuncios, setAnuncios] = useState<AnuncioApiDTO[]>([]);
  const [dashBoard, setDashBoard] = useState<DashBoardCompany | null>(null);
  const [revendaInfo, setRevendaInfo] = useState<RevendaInfoDetailsDTO | null>(null);
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;
  const totalPages = Math.ceil(anuncios.length / rowsPerPage);
  const anunciosPaginados = anuncios.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage );
  const { setToast } = useToastStore();
  const debounceTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  const search = useRef("");
  const [searchText, setSearchText] = useState("");
  const [filtroAtivo, setFiltroAtivo] = useState<string | null>(null);
  const filtroAtivoRef = useRef<string | null>(null);
  const hoje = new Date().toISOString().split("T")[0];
  const trintaDiasAtras = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split("T")[0];
  const [dataInicio, setDataInicio] = useState<string>(trintaDiasAtras);
  const [dataFim, setDataFim] = useState<string>(hoje);
  const [exporting, setExporting] = useState(false);
  const [anuncioAcessos, setAnuncioAcessos] = useState<AnuncioAcessoDTO[] | null>(null);
  const [loadingAcessos, setLoadingAcessos] = useState(false);
  const [acessosPage, setAcessosPage] = useState(0);
  const acessosRowsPerPage = 10;
  const [cotacaoDialog, setCotacaoDialog] = useState<{
    open: boolean;
    valor: number;
    revenda: string;
    idAnuncio: number;
  }>({ open: false, valor: 0, revenda: "", idAnuncio: 0 });

  const handleOpenBuyerDialog = async (id_revenda: number) => {
    await fetchRevenda(id_revenda);
  };

  const handleOpenCotacaoDialog = (idAnuncio: number, valor: number, revenda: string, tag_status: string, tag_ativo: string, tipo_anuncio: string) => {
    if(tipo_anuncio !== "C") return;
    // if(tag_status !== "Em Aberto") return;
    if(tag_ativo !=="1" ) return;
    setCotacaoDialog({ open: true, valor, revenda, idAnuncio });
  };

  const handleAceitarCotacao =  async(id_anuncio: number) => {
    try {
      setLoading(true);
      const result = await allowCotacao(id_anuncio);
      if (!result?.success) {
        setToast({ message: result.message ?? "Erro. Contate o administrador", variant: "error" });
        return;
      }
      setToast({ message: "Cotação aceita com sucesso!", variant: "success" });
      setCotacaoDialog({ open: false, valor: 0, revenda: "", idAnuncio: 0 });
      window.location.reload();
    } catch (error: any) {
      setToast({ message: error.response.data.message ?? "Erro. Contate o administrador", variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleRecusarCotacao = async (id_anuncio: number) => {
    try {
      setLoading(true);
      const result = await rejectCotacao(id_anuncio);
      if (!result?.success) {
        setToast({ message: result.message ?? "Erro. Contate o administrador", variant: "error" });
        return;
      }
      setToast({ message: result.message ?? "Cotação recusada com sucesso!", variant: "success" });
      setCotacaoDialog({ open: false, valor: 0, revenda: "", idAnuncio: 0 });
      window.location.reload();
    } catch (error: any) {
      setToast({ message: error.response.data.message ?? "Erro. Contate o administrador", variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleOpenAcessoDialog = async (id_anuncio: number) => {
    try {
      setLoadingAcessos(true);
      setAnuncioAcessos([]);
      const result = await fetchAnuncioAcesso(id_anuncio);
      if (!result?.success) {
        setToast({
          message: result.message ?? "Erro. Contate o administrador",
          variant: "error",
        });
        setAnuncioAcessos(null);
        return;
      }
      setAnuncioAcessos(result.data);
      setAcessosPage(0);
    } catch {
      setToast({
        message: "Erro. Contate o administrador",
        variant: "error",
      });
      setAnuncioAcessos(null);
    } finally {
      setLoadingAcessos(false);
    }
  };

  const debounceSearch = async () => {
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(async () => {
      const value = search.current.trim();
      if (value !== "" && value.length < 3) return;
      await fetchData(filtroAtivoRef.current, dataInicio, dataFim);
    }, 3000);
  };

  const handleFiltroCard = async (tipo: string) => {
    const novo = filtroAtivoRef.current === tipo ? null : tipo;
    filtroAtivoRef.current = novo;
    setFiltroAtivo(novo);
    await fetchData(novo, dataInicio, dataFim);
  };

  const handleExportPdf = async () => {
    setExporting(true);
    const result = await exportAnunciosPdf(search.current, filtroAtivoRef.current, dataInicio, dataFim);
    if (!result.success) setToast({ message: result.message ?? "Erro ao exportar PDF.", variant: "error" });
    setExporting(false);
  };

  const handleExportExcel = async () => {
    setExporting(true);
    const result = await exportAnunciosExcel(search.current, filtroAtivoRef.current, dataInicio, dataFim);
    if (!result.success) setToast({ message: result.message ?? "Erro ao exportar Excel.", variant: "error" });
    setExporting(false);
  };

  const handleLimparFiltros = async () => {
    filtroAtivoRef.current = null;
    setFiltroAtivo(null);
    search.current = "";
    setSearchText("");
    setDataInicio(hoje);
    setDataFim(hoje);
    await fetchData(null, hoje, hoje);
    await fetchDashBoard(hoje, hoje);
  };

  const fetchDashBoard = async (dtInicio?: string, dtFim?: string) => {
    try {
      const result = await fetchDashBoardComapny(dtInicio, dtFim);
      if (!result?.success) {
        setToast({
          message: result.message ?? "Erro. Contate o administrador",
          variant: "error",
        });
        setError(true);
        return;
      }
      setDashBoard(result.data);
    } catch (error) {
      setToast({
        message: "Erro. Contate o administrador",
        variant: "error",
      });
      setError(true);
    }
  };

  const fetchData = async (tipo_anuncio?: string | null, dtInicio?: string, dtFim?: string) => {
    try {
      setLoading(true);
      const result = await fetchAnunciosCompany(search.current, tipo_anuncio, dtInicio || null, dtFim || null);
      if (!result?.success) {
        setToast({
          message: result.message ?? "Erro. Contate o administrador",
          variant: "error",
        });
        setError(true);
        return;
      }
      setAnuncios(result.data);
    } catch (error) {
      setToast({
        message: "Erro. Contate o administrador",
        variant: "error",
      });
      setError(true);
    } finally {
      setLoading(false);
    }
  };

const fetchRevenda = async (id_revenda: number) => { 
  try {
    setLoading(true);
    const result = await fetchRevendaInfoDetails(id_revenda);
    if (!result?.success) {
      setToast({
        message: result.message ?? "Erro. Contate o administrador",
        variant: "error",
      });
      return;
    }
    setRevendaInfo(result.data);
  } catch (error) {
    setToast({
      message: "Erro. Contate o administrador",
      variant: "error",
    });
    return;
  } finally {
    setLoading(false);
  }
}


  useEffect(() => {
    if (jaCarregouRef.current) return;
    jaCarregouRef.current = true;
    const loadData = async () => {
      await fetchData(null, trintaDiasAtras, hoje);
      await fetchDashBoard(trintaDiasAtras, hoje);
      setLoading(false);
    };
    loadData();
  }, []);

  if (isLoading) return <Loading fullScreen={true} />;
  if (error) return <ErrorScreen fullScreen={true} />;

  return (
    <>
      <RevendaInfoDialog
        open={Boolean(revendaInfo)}
        onClose={() => setRevendaInfo(null)}
        data={revendaInfo}
      />

      <Dialog
        open={cotacaoDialog.open}
        onClose={() => setCotacaoDialog({ open: false, valor: 0, revenda: "", idAnuncio: 0 })}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            overflow: "hidden",
            boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
          },
        }}
      >
        {/* Header com gradiente */}
        <Box
          sx={{
            background: `linear-gradient(135deg, ${colorPrimary} 0%, #ff8c38 100%)`,
            px: 3,
            py: 2.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box display="flex" alignItems="center" gap={1.5}>
            <Box
              sx={{
                bgcolor: "rgba(255,255,255,0.2)",
                borderRadius: 2,
                width: 36,
                height: 36,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Handshake size={20} color="#fff" />
            </Box>
            <Typography fontWeight={700} fontSize="1.05rem" color="#fff">
              Última Cotação
            </Typography>
          </Box>
          <IconButton
            size="small"
            onClick={() => setCotacaoDialog({ open: false, valor: 0, revenda: "", idAnuncio: 0 })}
            sx={{
              color: "rgba(255,255,255,0.8)",
              "&:hover": { bgcolor: "rgba(255,255,255,0.15)", color: "#fff" },
            }}
          >
            <X size={18} />
          </IconButton>
        </Box>

        <DialogContent sx={{ px: 3, pt: 3, pb: 1 }}>
          {/* Card com o valor em destaque */}
          <Box
            sx={{
              bgcolor: "#FFF7F0",
              border: "1px solid rgba(254,102,0,0.15)",
              borderRadius: 3,
              p: 2.5,
              textAlign: "center",
              mb: 2.5,
            }}
          >
            <Typography fontSize="0.78rem" color="#6B7588" fontWeight={500} letterSpacing={0.5} textTransform="uppercase">
              Valor da oferta
            </Typography>
            <Typography fontSize="1.75rem" fontWeight={800} color={colorPrimary} mt={0.5}>
              {formatCurrencyBRL(cotacaoDialog.valor)}
            </Typography>
          </Box>

          {/* Info da revenda */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              bgcolor: "#F8F9FB",
              borderRadius: 2.5,
              px: 2,
              py: 1.5,
              mb: 2,
            }}
          >
            <Box
              sx={{
                bgcolor: "#E8EBF0",
                borderRadius: "50%",
                width: 32,
                height: 32,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <User size={16} color="#6B7588" />
            </Box>
            <Box>
              <Typography fontSize="0.7rem" color="#6B7588" fontWeight={500}>
                Revenda
              </Typography>
              <Typography fontSize="0.88rem" fontWeight={600} color="#1A2138">
                {cotacaoDialog.revenda.toUpperCase()}
              </Typography>
            </Box>
          </Box>

          <Typography fontSize="0.88rem" color="#6B7588" textAlign="center" lineHeight={1.6}>
            Deseja <strong style={{ color: "#06c270" }}>aceitar</strong> ou{" "}
            <strong style={{ color: "#e53935" }}>recusar</strong> esta cotação?
          </Typography>
        </DialogContent>

        <DialogActions sx={{ px: 3, pb: 2.5, pt: 1, gap: 1.5 }}>
          <Button
            disabled={isLoading}
            variant="outlined"
            onClick={() => handleRecusarCotacao(cotacaoDialog.idAnuncio)}
            startIcon={<XCircle size={17} />}
            sx={{
              flex: 1,
              borderRadius: 2.5,
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.88rem",
              py: 1.1,
              color: "#e53935",
              borderColor: "rgba(229,57,53,0.35)",
              "&:hover": {
                bgcolor: "rgba(229,57,53,0.06)",
                borderColor: "#e53935",
              },
            }}
          >
            {isLoading ? <CircularProgress size={16} thickness={4} sx={{ color: "#e53935" }} /> : "Recusar"}
          </Button>
          <Button
            disabled={isLoading}
            variant="contained"
            onClick={() => handleAceitarCotacao(cotacaoDialog.idAnuncio)}
            startIcon={<CheckCircle size={17} />}
            sx={{
              flex: 1,
              borderRadius: 2.5,
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.88rem",
              py: 1.1,
              bgcolor: "#06c270",
              boxShadow: "0 4px 14px rgba(6,194,112,0.3)",
              "&:hover": {
                bgcolor: "#05a85f",
                boxShadow: "0 6px 20px rgba(6,194,112,0.4)",
              },
            }}
          >
            {isLoading ? <CircularProgress size={16} thickness={4} sx={{ color: "#fff" }} /> : "Aceitar"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={anuncioAcessos !== null}
        onClose={() => { setAnuncioAcessos(null); setAcessosPage(0); }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            overflow: "hidden",
            boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
          },
        }}
      >
        <Box
          sx={{
            background: "linear-gradient(135deg, #1e293b 0%, #334155 100%)",
            px: 3,
            py: 2.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box display="flex" alignItems="center" gap={1.5}>
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: 2,
                bgcolor: "rgba(255,255,255,0.12)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Eye size={20} color="#fff" />
            </Box>
            <Box>
              <Typography fontWeight={700} fontSize="1.05rem" color="#fff">
                Visualizações
              </Typography>
              {!loadingAcessos && anuncioAcessos && anuncioAcessos.length > 0 && (
                <Typography fontSize="0.75rem" color="rgba(255,255,255,0.6)">
                  {anuncioAcessos.length} acesso{anuncioAcessos.length !== 1 ? "s" : ""} registrado{anuncioAcessos.length !== 1 ? "s" : ""}
                </Typography>
              )}
            </Box>
          </Box>
          <IconButton onClick={() => { setAnuncioAcessos(null); setAcessosPage(0); }} size="small" sx={{ color: "rgba(255,255,255,0.6)", "&:hover": { color: "#fff", bgcolor: "rgba(255,255,255,0.1)" } }}>
            <X size={18} />
          </IconButton>
        </Box>

        <DialogContent sx={{ p: 0 }}>
          {loadingAcessos ? (
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight={160} gap={1.5}>
              <CircularProgress size={32} thickness={4} sx={{ color: "#475569" }} />
              <Typography fontSize="0.8rem" color="#94a3b8">Carregando acessos...</Typography>
            </Box>
          ) : anuncioAcessos && anuncioAcessos.length > 0 ? (
            <>
              <Box>
                {anuncioAcessos
                  .slice(acessosPage * acessosRowsPerPage, acessosPage * acessosRowsPerPage + acessosRowsPerPage)
                  .map((acesso, idx) => {
                    const globalIdx = acessosPage * acessosRowsPerPage + idx;
                    return (
                      <Box
                        key={globalIdx}
                        onClick={() => {
                          if (acesso.tipo_acesso === "Revenda") {
                            setAnuncioAcessos(null);
                            setAcessosPage(0);
                            fetchRevenda(acesso.id);
                          } else {
                            setToast({ message: "Informações de concessionária, não permitido.", variant: "warning" });
                          }
                        }}
                        sx={{
                          px: 3,
                          py: 1.8,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 2,
                          cursor: "pointer",
                          borderBottom: globalIdx < anuncioAcessos.length - 1 ? "1px solid #f1f5f9" : "none",
                          transition: "background 0.15s",
                          "&:hover": { bgcolor: "#f8fafc" },
                        }}
                      >
                        <Box display="flex" alignItems="center" gap={1.5} minWidth={0} flex={1}>
                          <Box
                            sx={{
                              width: 34,
                              height: 34,
                              borderRadius: "50%",
                              bgcolor: "#eff6ff",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexShrink: 0,
                            }}
                          >
                            <User size={16} color="#3b82f6" />
                          </Box>
                          <Box minWidth={0}>
                            <Typography
                              fontSize="0.82rem"
                              fontWeight={600}
                              color="#1e293b"
                              noWrap
                              title={acesso.nome ?? "-"}
                            >
                              {acesso.nome ?? "-"}
                            </Typography>
                            <Typography fontSize="0.72rem" color="#94a3b8">
                              {acesso.data_cadastro
                                ? (() => {
                                    const d = new Date(acesso.data_cadastro);
                                    const day = String(d.getDate()).padStart(2, "0");
                                    const month = String(d.getMonth() + 1).padStart(2, "0");
                                    const year = d.getFullYear();
                                    const hours = String(d.getHours()).padStart(2, "0");
                                    const minutes = String(d.getMinutes()).padStart(2, "0");
                                    return `${day}/${month}/${year} às ${hours}:${minutes}`;
                                  })()
                                : "-"}
                            </Typography>
                          </Box>
                        </Box>
                        <Chip
                          icon={acesso.plataforma === "App" ? <Smartphone size={12} /> : <Monitor size={12} />}
                          label={acesso.plataforma ?? "-"}
                          size="small"
                          sx={{
                            flexShrink: 0,
                            height: 26,
                            fontSize: "0.7rem",
                            fontWeight: 600,
                            bgcolor: acesso.plataforma === "App" ? "#f0fdf4" : "#eff6ff",
                            color: acesso.plataforma === "App" ? "#16a34a" : "#2563eb",
                            border: `1px solid ${acesso.plataforma === "App" ? "#bbf7d0" : "#bfdbfe"}`,
                            "& .MuiChip-icon": {
                              color: "inherit",
                              ml: 0.5,
                            },
                          }}
                        />
                      </Box>
                    );
                  })}
              </Box>
              {anuncioAcessos.length > acessosRowsPerPage && (
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  px={3}
                  py={1.5}
                  borderTop="1px solid #f1f5f9"
                >
                  <Typography fontSize="0.72rem" color="#94a3b8">
                    {acessosPage * acessosRowsPerPage + 1}–{Math.min((acessosPage + 1) * acessosRowsPerPage, anuncioAcessos.length)} de {anuncioAcessos.length}
                  </Typography>
                  <Box display="flex" gap={0.5}>
                    <IconButton
                      size="small"
                      disabled={acessosPage === 0}
                      onClick={() => setAcessosPage((p) => p - 1)}
                      sx={{ color: acessosPage === 0 ? "#cbd5e1" : "#475569" }}
                    >
                      <ChevronLeft size={16} />
                    </IconButton>
                    <IconButton
                      size="small"
                      disabled={(acessosPage + 1) * acessosRowsPerPage >= anuncioAcessos.length}
                      onClick={() => setAcessosPage((p) => p + 1)}
                      sx={{ color: (acessosPage + 1) * acessosRowsPerPage >= anuncioAcessos.length ? "#cbd5e1" : "#475569" }}
                    >
                      <ChevronRight size={16} />
                    </IconButton>
                  </Box>
                </Box>
              )}
            </>
          ) : (
            <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight={140} gap={1}>
              <Box sx={{ width: 48, height: 48, borderRadius: "50%", bgcolor: "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Eye size={22} color="#94a3b8" />
              </Box>
              <Typography fontSize="0.85rem" color="#94a3b8" fontWeight={500}>
                Nenhuma visualização registrada
              </Typography>
            </Box>
          )}
        </DialogContent>
      </Dialog>

      {isMobile ? (
        <MobileView
          dashBoard={dashBoard}
          anuncios={anuncios}
          anunciosPaginados={anunciosPaginados}
          isLoading={isLoading}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}
          search={search}
          searchText={searchText}
          setSearchText={setSearchText}
          debounceSearch={debounceSearch}
          navigate={navigate}
          theme={theme}
          filtroAtivo={filtroAtivo}
          onFiltroCard={handleFiltroCard}
          onOpenBuyerDialog={handleOpenBuyerDialog}
          onOpenAcessoDialog={handleOpenAcessoDialog}
          onOpenCotacaoDialog={handleOpenCotacaoDialog}
          dataInicio={dataInicio}
          dataFim={dataFim}
          setDataInicio={setDataInicio}
          setDataFim={setDataFim}
          fetchData={fetchData}
          fetchDashBoard={fetchDashBoard}
          filtroAtivoRef={filtroAtivoRef}
          onExportPdf={handleExportPdf}
          onExportExcel={handleExportExcel}
          exporting={exporting}
          onLimparFiltros={handleLimparFiltros}
          isAdmin={isAdmin}
        />
      ) : (
        <DesktopView
          dashBoard={dashBoard}
          anuncios={anuncios}
          anunciosPaginados={anunciosPaginados}
          isLoading={isLoading}
          page={page}
          setPage={setPage}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}
          search={search}
          searchText={searchText}
          setSearchText={setSearchText}
          debounceSearch={debounceSearch}
          navigate={navigate}
          theme={theme}
          filtroAtivo={filtroAtivo}
          onFiltroCard={handleFiltroCard}
          onOpenBuyerDialog={handleOpenBuyerDialog}
          onOpenAcessoDialog={handleOpenAcessoDialog}
          onOpenCotacaoDialog={handleOpenCotacaoDialog}
          dataInicio={dataInicio}
          dataFim={dataFim}
          setDataInicio={setDataInicio}
          setDataFim={setDataFim}
          fetchData={fetchData}
          fetchDashBoard={fetchDashBoard}
          filtroAtivoRef={filtroAtivoRef}
          onExportPdf={handleExportPdf}
          onExportExcel={handleExportExcel}
          exporting={exporting}
          onLimparFiltros={handleLimparFiltros}
          isAdmin={isAdmin}
        />
      )}
    </>
  );
}

/* ------------------------------------------------------------------ */
/*  Shared props                                                       */
/* ------------------------------------------------------------------ */

interface ViewProps {
  dashBoard: DashBoardCompany | null;
  anuncios: AnuncioApiDTO[];
  anunciosPaginados: AnuncioApiDTO[];
  isLoading: boolean;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  totalPages: number;
  rowsPerPage: number;
  search: React.MutableRefObject<string>;
  searchText: string;
  setSearchText: React.Dispatch<React.SetStateAction<string>>;
  debounceSearch: () => Promise<void>;
  navigate: ReturnType<typeof useNavigate>;
  theme: Theme;
  filtroAtivo: string | null;
  onFiltroCard: (tipo: string) => Promise<void>;
  onOpenBuyerDialog: (id_revenda: number) => Promise<void>;
  onOpenAcessoDialog: (id_anuncio: number) => Promise<void>;
  onOpenCotacaoDialog: (idAnuncio: number, valor: number, revenda: string, tag_status: string, tag_ativo: string, tipo_anuncio: string) => void;
  dataInicio: string;
  dataFim: string;
  setDataInicio: React.Dispatch<React.SetStateAction<string>>;
  setDataFim: React.Dispatch<React.SetStateAction<string>>;
  fetchData: (tipo_anuncio?: string | null, dtInicio?: string, dtFim?: string) => Promise<void>;
  fetchDashBoard: (dtInicio?: string, dtFim?: string) => Promise<void>;
  filtroAtivoRef: React.MutableRefObject<string | null>;
  onExportPdf: () => Promise<void>;
  onExportExcel: () => Promise<void>;
  exporting: boolean;
  onLimparFiltros: () => Promise<void>;
  isAdmin: boolean;
}

/* ------------------------------------------------------------------ */
/*  Sortable columns config                                            */
/* ------------------------------------------------------------------ */

type SortableKey = "id_anuncio" | "concessionaria" | "data_cadastro" | "data_venda" | "data_atualizacao" | "val_inicial" | "tag_status" | "qtd_total_click";
type SortDirection = "asc" | "desc";

const TABLE_COLUMNS: { label: string; sortKey?: SortableKey }[] = [
  { label: "Anúncio", sortKey: "id_anuncio" },
  { label: "Veículo" },
  { label: "Concessionária", sortKey: "concessionaria" },
  { label: "Cadastro", sortKey: "data_cadastro" },
  { label: "Venda", sortKey: "data_venda" },
  { label: "Atualização", sortKey: "data_atualizacao" },
  { label: "Valor Inicial", sortKey: "val_inicial" },
  { label: "Melhor Oferta" },
  { label: "Status", sortKey: "tag_status" },
  { label: "Views", sortKey: "qtd_total_click" },
  { label: "Ações" },
];

/* ------------------------------------------------------------------ */
/*  DESKTOP VIEW  (original layout)                                    */
/* ------------------------------------------------------------------ */

function DesktopView({
  dashBoard,
  anuncios,
  anunciosPaginados,
  isLoading,
  page,
  setPage,
  totalPages,
  rowsPerPage,
  search,
  searchText,
  setSearchText,
  debounceSearch,
  navigate,
  theme,
  filtroAtivo,
  onFiltroCard,
  onOpenBuyerDialog,
  onOpenAcessoDialog,
  onOpenCotacaoDialog,
  dataInicio,
  dataFim,
  setDataInicio,
  setDataFim,
  fetchData,
  fetchDashBoard,
  filtroAtivoRef,
  onExportPdf,
  onExportExcel,
  exporting,
  onLimparFiltros,
  isAdmin,
}: ViewProps) {
  const [expandedRows, setExpandedRows] = useState<number[]>([]);
  const [orderBy, setOrderBy] = useState<SortableKey | null>(null);
  const [orderDir, setOrderDir] = useState<SortDirection>("asc");

  const toggleRowExpansion = (id: number) => {
    setExpandedRows((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id]
    );
  };

  const handleSort = (key: SortableKey) => {
    if (orderBy === key) {
      setOrderDir((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setOrderBy(key);
      setOrderDir("asc");
    }
    setPage(0);
  };

  const sortedAnuncios = useMemo(() => {
    if (!orderBy) return anuncios;
    return [...anuncios].sort((a, b) => {
      const valA = a[orderBy];
      const valB = b[orderBy];
      let cmp = 0;
      if (typeof valA === "string" && typeof valB === "string") {
        cmp = valA.localeCompare(valB, "pt-BR", { sensitivity: "base" });
      } else if (typeof valA === "number" && typeof valB === "number") {
        cmp = valA - valB;
      } else {
        cmp = String(valA ?? "").localeCompare(String(valB ?? ""), "pt-BR");
      }
      return orderDir === "asc" ? cmp : -cmp;
    });
  }, [anuncios, orderBy, orderDir]);

  const sortedPaginados = sortedAnuncios.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box width="100%" height="100vdh" minHeight={0} flexDirection="column">
      {/* Dashboard cards */}
      <Box
        display="grid"
        gridTemplateColumns="repeat(6, 1fr)"
        gap={2}
        mt={2}
        alignItems="stretch"
      >
        <DashboardStatCard
          fetchData={() => onFiltroCard("Anuncio aberto")}
          isActive={filtroAtivo === "Anuncio aberto"}
          value={dashBoard?.em_aberto ?? 0}
          label="Anúncios em aberto"
          icon={<Clock size={34} />}
          accentColor="#3b82f6"
          bgColor="#eff6ff"
        />
        <DashboardStatCard
          fetchData={() => onFiltroCard("Anuncio vendido")}
          isActive={filtroAtivo === "Anuncio vendido"}
          value={dashBoard?.vendido ?? 0}
          label="Anúncios vendidos"
          icon={<CheckCircle size={34} />}
          accentColor="#16a34a"
          bgColor="#ecfdf5"
        />
        {isAdmin && (
          <DashboardStatCard
            fetchData={() => onFiltroCard("Anuncio nao vendido")}
            isActive={filtroAtivo === "Anuncio nao vendido"}
            value={dashBoard?.nao_vendido ?? 0}
            label="Anúncios não vendidos"
            icon={<XCircle size={34} />}
            accentColor="#dc2626"
            bgColor="#fef2f2"
          />
        )}
        <DashboardStatCard
          fetchData={() => onFiltroCard("Cotacao aberto")}
          isActive={filtroAtivo === "Cotacao aberto"}
          value={dashBoard?.cotacao_aberto ?? 0}
          label="Cotações em aberto"
          icon={<FileText size={34} />}
          accentColor="#0ea5e9"
          bgColor="#f0f9ff"
        />
        <DashboardStatCard
          fetchData={() => onFiltroCard("Cotacao vendido")}
          isActive={filtroAtivo === "Cotacao vendido"}
          value={dashBoard?.cotacao_vendida ?? 0}
          label="Cotação vendidas"
          icon={<Handshake size={34} />}
          accentColor="#7c3aed"
          bgColor="#f5f3ff"
        />
        <DashboardStatCard
          fetchData={() => onFiltroCard("Cotacao nao vendido")}
          isActive={filtroAtivo === "Cotacao nao vendido"}
          value={dashBoard?.cotacao_nao_vendido ?? 0}
          label="Cotações não vendidas"
          icon={<XCircle size={34} />}
          accentColor="#9f1239"
          bgColor="#fff1f2"
        />
        <DashboardStatCard
          fetchData={() => onFiltroCard("Combo aberto")}
          isActive={filtroAtivo === "Combo aberto"}
          value={dashBoard?.combo_aberto ?? 0}
          label="Combos em aberto"
          icon={<XCircle size={34} />}
          accentColor="#f59e0b"
          bgColor="#fffbeb"
        />
        <DashboardStatCard
          fetchData={() => onFiltroCard("Combo nao vendido")}
          isActive={filtroAtivo === "Combo nao vendido"}
          value={dashBoard?.combo_nao_vendido ?? 0}
          label="Combos não vendidos"
          icon={<XCircle size={34} />}
          accentColor="#64748b"
          bgColor="#f1f5f9"
        />
        <DashboardStatCard
          fetchData={() => onFiltroCard("Combo vendido")}
          isActive={filtroAtivo === "Combo vendido"}
          value={dashBoard?.combo_vendido ?? 0}
          label="Combos vendidos"
          icon={<XCircle size={34} />}
          accentColor="#0d9488"
          bgColor="#f0fdfa"
        />
        <DashboardStatCard
          fetchData={() => onFiltroCard("Veiculo aberto")}
          isActive={filtroAtivo === "Veiculo aberto"}
          value={dashBoard?.veiculos_em_aberto ?? 0}
          label="Veículos em aberto"
          icon={<Car size={34} />}
          accentColor="#2563eb"
          bgColor="#eff6ff"
        />
        <DashboardStatCard
          fetchData={() => onFiltroCard("Veiculo vendido")}
          isActive={filtroAtivo === "Veiculo vendido"}
          value={dashBoard?.veiculos_vendido ?? 0}
          label="Veículos vendidos"
          icon={<Car size={34} />}
          accentColor="#059669"
          bgColor="#ecfdf5"
        />
        <DashboardStatCard
          fetchData={() => onFiltroCard("Veiculo nao vendido")}
          isActive={filtroAtivo === "Veiculo nao vendido"}
          value={dashBoard?.veiculos_nao_vendido ?? 0}
          label="Veículos não vendidos"
          icon={<Car size={34} />}
          accentColor="#b91c1c"
          bgColor="#fef2f2"
        />
        <DashboardStatCard
          fetchData={() => onFiltroCard("Anuncio encerrado")}
          isActive={filtroAtivo === "Anuncio encerrado"}
          value={dashBoard?.anuncio_encerrado ?? 0}
          label="Anúncios encerrados"
          icon={<Archive size={34} />}
          accentColor="#475569"
          bgColor="#f8fafc"
        />
        <DashboardStatCard
          fetchData={() => onFiltroCard("Anuncio inativo")}
          isActive={filtroAtivo === "Anuncio inativo"}
          value={dashBoard?.anuncio_inativo ?? 0}
          label="Anúncios inativos"
          icon={<Ban size={34} />}
          accentColor="#a16207"
          bgColor="#fefce8"
        />
      </Box>

      {/* Table section */}
      <Box
        width="100%"
        minHeight={0}
        flexDirection="column"
        border={bordasComponents}
        borderRadius={3}
        bgcolor="white"
        p={5}
        mt={6}
      >
        <Stack
          display="flex"
          flexDirection="row"
          width="100%"
          minHeight={0}
          justifyContent="space-between"
          alignContent="flex-end"
          alignItems="flex-end"
        >
          <Box display="flex" flexDirection="column" minHeight={0}>
            <Typography fontWeight={600} fontSize="1.8rem" color="black">
              Meus Anúncios e Cotações
            </Typography>
            <Typography fontWeight={300} fontSize="1.1rem" color={colorSubText}>
              Gerencie seus veículos, ofertas e cotações ativas no marktplace.
            </Typography>
          </Box>
          <Stack direction="row" spacing={2}>
            <ActionButton
              label="Novo Anúncio"
              icon={<AddCircleIcon />}
              variantType="primary"
              onClick={() => navigate("/anuncios/novo")}
            />
            <ActionButton
              label="Novo Combo"
              icon={<LayersIcon />}
              variantType="dark"
              onClick={() => navigate("/anuncios/novo/combo")}
            />
          </Stack>
        </Stack>

        {/* Search + Date Filters */}
        <Stack direction="row" spacing={2} alignItems="center" mt={2} flexWrap="wrap">
          <TextField
            placeholder="Procurar veículos..."
            size="medium"
            value={searchText}
            onChange={(e) => {
              setSearchText(e.target.value);
              search.current = e.target.value;
              debounceSearch();
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            sx={{
              backgroundColor: (t) =>
                t.palette.mode === "dark" ? "#020617" : "#f8fafc",
              borderRadius: 3,
              minWidth: 400,
              flex: 1,
              maxHeight: 50,
              "& .MuiOutlinedInput-root": {
                borderRadius: 3,
                maxHeight: 50,
                fontSize: 14,
                "& fieldset": {
                  borderColor: (t) =>
                    t.palette.mode === "dark" ? "#334155" : "#e2e8f0",
                },
                "&:hover fieldset": { borderColor: "primary.main" },
                "&.Mui-focused fieldset": {
                  borderColor: "primary.main",
                  borderWidth: 2,
                },
              },
            }}
          />
          <TextField
            label="Data Início"
            type="date"
            size="medium"
            value={dataInicio}
            onChange={(e) => setDataInicio(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{
              minWidth: 170,
              maxHeight: 50,
              backgroundColor: (t) =>
                t.palette.mode === "dark" ? "#020617" : "#f8fafc",
              borderRadius: 3,
              "& .MuiOutlinedInput-root": {
                borderRadius: 3,
                maxHeight: 50,
                fontSize: 14,
                "& fieldset": {
                  borderColor: (t) =>
                    t.palette.mode === "dark" ? "#334155" : "#e2e8f0",
                },
                "&:hover fieldset": { borderColor: "primary.main" },
                "&.Mui-focused fieldset": {
                  borderColor: "primary.main",
                  borderWidth: 2,
                },
              },
            }}
          />
          <TextField
            label="Data Fim"
            type="date"
            size="medium"
            value={dataFim}
            onChange={(e) => setDataFim(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{
              minWidth: 170,
              maxHeight: 50,
              backgroundColor: (t) =>
                t.palette.mode === "dark" ? "#020617" : "#f8fafc",
              borderRadius: 3,
              "& .MuiOutlinedInput-root": {
                borderRadius: 3,
                maxHeight: 50,
                fontSize: 14,
                "& fieldset": {
                  borderColor: (t) =>
                    t.palette.mode === "dark" ? "#334155" : "#e2e8f0",
                },
                "&:hover fieldset": { borderColor: "primary.main" },
                "&.Mui-focused fieldset": {
                  borderColor: "primary.main",
                  borderWidth: 2,
                },
              },
            }}
          />
          <Button
            variant="outlined"
            onClick={() => { fetchData(filtroAtivoRef.current, dataInicio, dataFim); fetchDashBoard(dataInicio, dataFim); }}
            startIcon={<SearchIcon fontSize="small" />}
            sx={{
              height: 50,
              borderRadius: 3,
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              fontSize: 14,
              borderColor: (t) =>
                t.palette.mode === "dark" ? "#334155" : "#e2e8f0",
              color: (t) =>
                t.palette.mode === "dark" ? "#94a3b8" : "#475569",
              backgroundColor: (t) =>
                t.palette.mode === "dark" ? "#020617" : "#f8fafc",
              whiteSpace: "nowrap",
              "&:hover": {
                borderColor: "primary.main",
                color: "primary.main",
                backgroundColor: (t) =>
                  t.palette.mode === "dark" ? "#0f172a" : "#f0f7ff",
              },
            }}
          >
            Filtrar
          </Button>
          <Button
            variant="outlined"
            onClick={onLimparFiltros}
            startIcon={<X size={16} />}
            sx={{
              height: 50,
              borderRadius: 3,
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              fontSize: 14,
              borderColor: (t) =>
                t.palette.mode === "dark" ? "#334155" : "#e2e8f0",
              color: (t) =>
                t.palette.mode === "dark" ? "#94a3b8" : "#475569",
              backgroundColor: (t) =>
                t.palette.mode === "dark" ? "#020617" : "#f8fafc",
              whiteSpace: "nowrap",
              "&:hover": {
                borderColor: "#ef4444",
                color: "#ef4444",
                backgroundColor: (t) =>
                  t.palette.mode === "dark" ? "#0f172a" : "#fef2f2",
              },
            }}
          >
            Limpar filtros
          </Button>
          <Button
            variant="outlined"
            onClick={onExportPdf}
            disabled={exporting}
            startIcon={<Download size={16} />}
            sx={{
              height: 50,
              borderRadius: 3,
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              fontSize: 14,
              borderColor: (t) =>
                t.palette.mode === "dark" ? "#334155" : "#e2e8f0",
              color: (t) =>
                t.palette.mode === "dark" ? "#94a3b8" : "#475569",
              backgroundColor: (t) =>
                t.palette.mode === "dark" ? "#020617" : "#f8fafc",
              whiteSpace: "nowrap",
              "&:hover": {
                borderColor: "#dc2626",
                color: "#dc2626",
                backgroundColor: (t) =>
                  t.palette.mode === "dark" ? "#0f172a" : "#fef2f2",
              },
            }}
          >
            PDF
          </Button>
          <Button
            variant="outlined"
            onClick={onExportExcel}
            disabled={exporting}
            startIcon={<Download size={16} />}
            sx={{
              height: 50,
              borderRadius: 3,
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              fontSize: 14,
              borderColor: (t) =>
                t.palette.mode === "dark" ? "#334155" : "#e2e8f0",
              color: (t) =>
                t.palette.mode === "dark" ? "#94a3b8" : "#475569",
              backgroundColor: (t) =>
                t.palette.mode === "dark" ? "#020617" : "#f8fafc",
              whiteSpace: "nowrap",
              "&:hover": {
                borderColor: "#2563eb",
                color: "#2563eb",
                backgroundColor: (t) =>
                  t.palette.mode === "dark" ? "#0f172a" : "#eff6ff",
              },
            }}
          >
            Excel
          </Button>
        </Stack>

        {/* Table */}
        {isLoading ? (
          <Box
            width="100%"
            minHeight={300}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap={2}
          >
            <CircularProgress size={42} thickness={4} />
            <Typography fontSize="0.85rem" color={colorSubText}>
              Carregando anúncios...
            </Typography>
          </Box>
        ) : anuncios.length > 0 ? (
          <TableContainer sx={{ maxHeight: "100%", mr: 5, mt: 2 }}>
            <Table
              stickyHeader
              sx={{
                bgcolor: "transparent",
                borderCollapse: "separate",
                borderSpacing: "0 8px",
              }}
            >
              <TableHead>
                <TableRow>
                  {TABLE_COLUMNS.map((col) => (
                    <TableCell
                      key={col.label}
                      align="left"
                      sortDirection={orderBy === col.sortKey ? orderDir : false}
                      sx={{
                        backgroundColor: "transparent",
                        color: colorSubText,
                        fontSize: "0.9rem",
                        fontWeight: 600,
                        textTransform: "uppercase",
                        borderBottom: "1px solid rgba(40, 61, 107, 0.4)",
                      }}
                    >
                      {col.sortKey ? (
                        <TableSortLabel
                          active={orderBy === col.sortKey}
                          direction={orderBy === col.sortKey ? orderDir : "asc"}
                          onClick={() => handleSort(col.sortKey!)}
                          sx={{
                            color: `${colorSubText} !important`,
                            "&:hover": { color: `${colorPrimary} !important` },
                            "&.Mui-active": { color: `${colorPrimary} !important` },
                            "& .MuiTableSortLabel-icon": {
                              color: `${colorPrimary} !important`,
                            },
                          }}
                        >
                          {col.label}
                        </TableSortLabel>
                      ) : (
                        col.label
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {sortedPaginados.map((row, index) => {
                  const tipo = row.veiculos.length > 1 ? "P" : row.tipo_anuncio === '' ? 'N' : row.tipo_anuncio;
                  const isExpanded = expandedRows.includes(row.id_anuncio);
                  return (
                  <Fragment key={`${row.id_anuncio}/${index}`}>
                    <TableRow
                      sx={{
                        alignContent: "center",
                        justifyContent: "center",
                        alignItems: "center",
                        justifyItems: "center",
                        backgroundColor: "rgba(255,255,255,0.02)",
                        transition: "all 0.25s ease",
                      }}
                    >
                      <TableCell sx={cellStyle}>
                        {tipoAnuncioChip(tipo)}
                      </TableCell>
                      <TableCell sx={cellStyle}>
                        {row.veiculos.length > 0 ? (
                          <Box display="flex" flexDirection="column" minHeight={0} maxWidth={230}>
                            <Typography
                              fontSize="0.8rem"
                              color="#6B7588"
                              lineHeight={1.2}
                            >
                              {row.veiculos[0].veiculo}
                              {row.veiculos.length > 1 && (
                                <Typography
                                  component="span"
                                  fontSize="0.75rem"
                                  color="#94a3b8"
                                >
                                  {" "}+ {row.veiculos.length - 1} veículo{row.veiculos.length - 1 > 1 ? "s" : ""}
                                </Typography>
                              )}
                            </Typography>
                            {row.veiculos.length > 1 && (
                              <Box
                                display="inline-flex"
                                alignItems="center"
                                gap={0.5}
                                mt={0.5}
                                sx={{ cursor: "pointer" }}
                                onClick={() => toggleRowExpansion(row.id_anuncio)}
                              >
                                <Typography
                                  fontSize="0.625rem"
                                  fontWeight={700}
                                  color={colorPrimary}
                                  textTransform="uppercase"
                                  letterSpacing={0.5}
                                  sx={{ "&:hover": { color: "#ea580c" } }}
                                >
                                  {isExpanded ? "Ocultar" : "Ver todos"}
                                </Typography>
                                <ChevronDown
                                  size={14}
                                  color={colorPrimary}
                                  style={{
                                    transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                                    transition: "transform 0.3s",
                                  }}
                                />
                              </Box>
                            )}
                          </Box>
                        ) : (
                          <Typography
                            fontSize="0.75rem"
                            color="#94a3b8"
                            fontStyle="italic"
                          >
                            Veículo não informado
                          </Typography>
                        )}
                      </TableCell>
                      <TableCell sx={{ ...cellStyleDestaque, color: "black" }}>
                        {row.concessionaria}
                      </TableCell>
                      <TableCell sx={cellStyle}>
                        {row.data_cadastro
                          ? new Date(row.data_cadastro).toLocaleDateString('pt-BR')
                          : '-'}
                      </TableCell>
                      <TableCell sx={cellStyle}>
                        {row.data_venda
                          ? new Date(row.data_venda).toLocaleString('pt-BR', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                            })
                          : '-'}
                      </TableCell>
                      <TableCell sx={cellStyle}>
                        {row.data_atualizacao
                          ? new Date(row.data_atualizacao).toLocaleString('pt-BR', {
                              day: '2-digit',
                              month: '2-digit',
                              year: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit',
                            })
                          : '-'}
                      </TableCell>
                      <TableCell sx={cellStyleDestaque}>
                        {formatCurrencyBRL(row.val_inicial)}
                      </TableCell>
                      <TableCell sx={cellStyleDestaque}>
                        <Box display="flex" flexDirection="column">
                          {row.revenda ? (
                            <Typography
                              color={colorPrimary}
                              fontWeight={600}
                              fontSize="0.85rem"
                              sx={{ cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
                              onClick={() => onOpenBuyerDialog(Number(row.revenda_maior_oferta ?? 0))}
                            >
                              {row.revenda}
                            </Typography>
                          ) : (
                            <Typography
                              color="black"
                              fontWeight={400}
                              fontSize="0.85rem"
                            >
                              -
                            </Typography>
                          )}
                          <Typography
                            color={row.maior_oferta != null ? colorPrimary : colorSubText}
                            fontWeight={500}
                            fontSize="0.85rem"
                            sx={row.maior_oferta != null ? { cursor: "pointer", "&:hover": { textDecoration: "underline" } } : undefined}
                            onClick={() => {
                              if (row.maior_oferta != null) {
                                onOpenCotacaoDialog(
                                  row.id_anuncio,
                                  row.maior_oferta,
                                  row.revenda ?? "",
                                  row.tag_status,
                                  row.tag_ativo,
                                  row.tipo_anuncio
                                );
                              }
                            }}
                          >
                            {row.maior_oferta != null
                              ? formatCurrencyBRL(row.maior_oferta)
                              : "-"}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell sx={cellStyle}>
                        {statusChip(row.tag_status)}
                      </TableCell>
                      <TableCell
                        sx={{ ...cellStyle, cursor: "pointer", "&:hover": { textDecoration: "underline" } }}
                        onClick={() => onOpenAcessoDialog(row.id_anuncio)}
                      >
                        <Box display="flex" alignItems="center" gap={0.5}>
                          <Eye size={14} color="#6B7588" />
                          <Typography fontSize="0.85rem" color={colorPrimary} fontWeight={600}>
                            {row.qtd_total_click}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell>
                        <TableActionsMenuContaPagar
                          editar={() => {
                            if (row.veiculos.length > 1) {
                              navigate(
                                `/anuncios/novo/combo/${row.id_anuncio}`
                              );
                            } else {
                              navigate(`/anuncios/novo/${row.id_anuncio}`);
                            }
                          }}
                          excluir={() => {}}
                          visualiazarAnuncio={() => {
                            if (row.tipo_anuncio === "P" || row.veiculos.length > 1) {
                              navigate(`/anuncios/detalhe/combo/${row.id_anuncio}`);
                            } else {
                              navigate(`/anuncios/detalhe/${row.id_anuncio}`);
                            }
                          }}
                          visualizarHistorico={() =>
                            navigate(`/anuncio/historico/${row.id_anuncio}`)
                          }
                          rowId={2}
                        />
                      </TableCell>
                    </TableRow>

                    {row.veiculos.length > 1 && (
                      <TableRow>
                        <TableCell
                          colSpan={9}
                          sx={{ py: 0, borderBottom: "none" }}
                        >
                          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                            <Box py={1.5} pl={6} pr={4}>
                              <Stack
                                spacing={0.75}
                                borderLeft="2px solid rgba(254, 102, 0, 0.2)"
                                pl={2}
                              >
                                {row.veiculos.map((v, i) => (
                                  <Box
                                    key={i}
                                    bgcolor="rgba(255,255,255,0.06)"
                                    p={1}
                                    borderRadius={1}
                                    border="1px solid rgba(40, 61, 107, 0.15)"
                                  >
                                    <Typography
                                      fontSize="0.8rem"
                                      fontWeight={600}
                                      color="#6B7588"
                                    >
                                      {v.veiculo}
                                    </Typography>
                                  </Box>
                                ))}
                              </Stack>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    )}
                  </Fragment>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Box
            width="100%"
            minHeight={200}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography fontSize="0.85rem" color={colorSubText}>
              Nenhum anúncio encontrado.
            </Typography>
          </Box>
        )}

        {/* Pagination */}
        {!isLoading && anuncios.length > rowsPerPage && (
          <Box
            mt={3}
            display="flex"
            justifyContent="center"
            alignItems="center"
            gap={2}
            mb={2}
          >
            <PaginationButton
              disabled={page === 0}
              onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
            >
              <ChevronLeft size={20} />
            </PaginationButton>
            <Box
              sx={{
                minWidth: 48,
                height: 36,
                borderRadius: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                fontSize: "0.9rem",
                color: "#fff",
                background: theme.palette.primary.main,
              }}
            >
              {page + 1}
            </Box>
            <PaginationButton
              disabled={page >= totalPages - 1}
              onClick={() =>
                setPage((prev) => Math.min(prev + 1, totalPages - 1))
              }
            >
              <ChevronRight size={20} />
            </PaginationButton>
          </Box>
        )}
      </Box>
    </Box>
  );
}

/* ------------------------------------------------------------------ */
/*  MOBILE VIEW                                                        */
/* ------------------------------------------------------------------ */

function MobileView({
  dashBoard,
  anuncios,
  anunciosPaginados,
  isLoading,
  page,
  setPage,
  totalPages,
  rowsPerPage,
  search,
  searchText,
  setSearchText,
  debounceSearch,
  navigate,
  theme,
  filtroAtivo,
  onFiltroCard,
  onOpenBuyerDialog,
  onOpenAcessoDialog,
  onOpenCotacaoDialog,
  dataInicio,
  dataFim,
  setDataInicio,
  setDataFim,
  fetchData,
  fetchDashBoard,
  filtroAtivoRef,
  onExportPdf,
  onExportExcel,
  exporting,
  onLimparFiltros,
  isAdmin,
}: ViewProps) {
  const [fabAnchor, setFabAnchor] = useState<null | HTMLElement>(null);

  return (
    <Box width="100%" minHeight={0} flexDirection="column" pb={10}>
      {/* Dashboard cards — horizontal scroll */}
      <Box
        display="flex"
        gap={1.5}
        mt={2}
        px={1}
        pb={1}
        sx={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}
      >
        {[
          {
            value: dashBoard?.em_aberto ?? 0,
            label: "Em aberto",
            icon: <Clock size={22} />,
            accent: "#3b82f6",
            bg: "#eff6ff",
            filtro: "Anuncio aberto",
          },
          {
            value: dashBoard?.vendido ?? 0,
            label: "Vendidos",
            icon: <CheckCircle size={22} />,
            accent: "#16a34a",
            bg: "#ecfdf5",
            filtro: "Anuncio vendido",
          },
          ...(isAdmin
            ? [
                {
                  value: dashBoard?.nao_vendido ?? 0,
                  label: "Não vendidos",
                  icon: <XCircle size={22} />,
                  accent: "#dc2626",
                  bg: "#fef2f2",
                  filtro: "Anuncio nao vendido",
                },
              ]
            : []),
          {
            value: dashBoard?.cotacao_aberto ?? 0,
            label: "Cot. aberto",
            icon: <FileText size={22} />,
            accent: "#0ea5e9",
            bg: "#f0f9ff",
            filtro: "Cotacao aberto",
          },
          {
            value: dashBoard?.cotacao_vendida ?? 0,
            label: "Cot. vendidas",
            icon: <Handshake size={22} />,
            accent: "#7c3aed",
            bg: "#f5f3ff",
            filtro: "Cotacao vendido",
          },
          {
            value: dashBoard?.cotacao_nao_vendido ?? 0,
            label: "Cot. não vendidas",
            icon: <XCircle size={22} />,
            accent: "#9f1239",
            bg: "#fff1f2",
            filtro: "Cotacao nao vendido",
          },
          {
            value: dashBoard?.combo_aberto ?? 0,
            label: "Combos abertos",
            icon: <XCircle size={22} />,
            accent: "#f59e0b",
            bg: "#fffbeb",
            filtro: "Combo aberto",
          },
          {
            value: dashBoard?.combo_nao_vendido ?? 0,
            label: "Combos não vend.",
            icon: <XCircle size={22} />,
            accent: "#64748b",
            bg: "#f1f5f9",
            filtro: "Combo nao vendido",
          },
          {
            value: dashBoard?.combo_vendido ?? 0,
            label: "Combos vendidos",
            icon: <XCircle size={22} />,
            accent: "#0d9488",
            bg: "#f0fdfa",
            filtro: "Combo vendido",
          },
          {
            value: dashBoard?.veiculos_em_aberto ?? 0,
            label: "Veíc. em aberto",
            icon: <Car size={22} />,
            accent: "#2563eb",
            bg: "#eff6ff",
            filtro: "Veiculo aberto",
          },
          {
            value: dashBoard?.veiculos_vendido ?? 0,
            label: "Veíc. vendidos",
            icon: <Car size={22} />,
            accent: "#059669",
            bg: "#ecfdf5",
            filtro: "Veiculo vendido",
          },
          {
            value: dashBoard?.veiculos_nao_vendido ?? 0,
            label: "Veíc. não vend.",
            icon: <Car size={22} />,
            accent: "#b91c1c",
            bg: "#fef2f2",
            filtro: "Veiculo nao vendido",
          },
          {
            value: dashBoard?.anuncio_encerrado ?? 0,
            label: "Encerrados",
            icon: <Archive size={22} />,
            accent: "#475569",
            bg: "#f8fafc",
            filtro: "Anuncio encerrado",
          },
          {
            value: dashBoard?.anuncio_inativo ?? 0,
            label: "Inativos",
            icon: <Ban size={22} />,
            accent: "#a16207",
            bg: "#fefce8",
            filtro: "Anuncio inativo",
          },
        ].map((card, i) => (
          <Box
            key={i}
            flexShrink={0}
            width={140}
            borderRadius={2}
            bgcolor={card.bg}
            onClick={() => onFiltroCard(card.filtro)}
            p={2}
            sx={{
              cursor: "pointer",
              outline: filtroAtivo === card.filtro ? `2px solid ${card.accent}` : "2px solid transparent",
              transition: "outline 0.2s ease",
            }}
          >
            <Box display="flex" alignItems="center" gap={1} mb={0.5}>
              <Box color={card.accent}>{card.icon}</Box>
            </Box>
            <Typography fontWeight={700} fontSize={22} color={card.accent}>
              {card.value}
            </Typography>
            <Typography
              fontWeight={600}
              fontSize="0.7rem"
              color={card.accent}
              noWrap
            >
              {card.label}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Title + Search */}
      <Box px={2} mt={3}>
        <Typography fontWeight={600} fontSize="1.25rem" color="black">
          Meus Anúncios
        </Typography>
        <Typography fontWeight={300} fontSize="0.85rem" color={colorSubText}>
          Gerencie seus veículos e cotações.
        </Typography>

        <TextField
          placeholder="Procurar veículos..."
          size="small"
          fullWidth
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value);
            search.current = e.target.value;
            debounceSearch();
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
          sx={{
            mt: 1.5,
            backgroundColor: "#f8fafc",
            borderRadius: 2,
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
              fontSize: 14,
              "& fieldset": { borderColor: "#e2e8f0" },
              "&:hover fieldset": { borderColor: "primary.main" },
              "&.Mui-focused fieldset": {
                borderColor: "primary.main",
                borderWidth: 2,
              },
            },
          }}
        />

        <Stack direction="row" spacing={1} mt={1.5}>
          <TextField
            label="Início"
            type="date"
            size="small"
            fullWidth
            value={dataInicio}
            onChange={(e) => setDataInicio(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{
              backgroundColor: "#f8fafc",
              borderRadius: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                fontSize: 13,
                "& fieldset": { borderColor: "#e2e8f0" },
                "&:hover fieldset": { borderColor: "primary.main" },
                "&.Mui-focused fieldset": {
                  borderColor: "primary.main",
                  borderWidth: 2,
                },
              },
            }}
          />
          <TextField
            label="Fim"
            type="date"
            size="small"
            fullWidth
            value={dataFim}
            onChange={(e) => setDataFim(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{
              backgroundColor: "#f8fafc",
              borderRadius: 2,
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                fontSize: 13,
                "& fieldset": { borderColor: "#e2e8f0" },
                "&:hover fieldset": { borderColor: "primary.main" },
                "&.Mui-focused fieldset": {
                  borderColor: "primary.main",
                  borderWidth: 2,
                },
              },
            }}
          />
        </Stack>
        <Button
          variant="outlined"
          fullWidth
          onClick={() => { fetchData(filtroAtivoRef.current, dataInicio, dataFim); fetchDashBoard(dataInicio, dataFim); }}
          startIcon={<SearchIcon fontSize="small" />}
          sx={{
            mt: 1.5,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            fontSize: 14,
            borderColor: "#e2e8f0",
            color: "#475569",
            backgroundColor: "#f8fafc",
            "&:hover": {
              borderColor: "primary.main",
              color: "primary.main",
              backgroundColor: "#f0f7ff",
            },
          }}
        >
          Filtrar por período
        </Button>
        <Button
          variant="outlined"
          fullWidth
          onClick={onLimparFiltros}
          startIcon={<X size={16} />}
          sx={{
            mt: 1,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            fontSize: 14,
            borderColor: "#e2e8f0",
            color: "#475569",
            backgroundColor: "#f8fafc",
            "&:hover": {
              borderColor: "#ef4444",
              color: "#ef4444",
              backgroundColor: "#fef2f2",
            },
          }}
        >
          Limpar filtros
        </Button>
        <Stack direction="row" spacing={1} mt={1.5}>
          <Button
            variant="outlined"
            fullWidth
            onClick={onExportPdf}
            disabled={exporting}
            startIcon={<Download size={14} />}
            sx={{
              height: 40,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              fontSize: 13,
              borderColor: "#e2e8f0",
              color: "#475569",
              "&:hover": { borderColor: "#dc2626", color: "#dc2626" },
            }}
          >
            PDF
          </Button>
          <Button
            variant="outlined"
            fullWidth
            onClick={onExportExcel}
            disabled={exporting}
            startIcon={<Download size={14} />}
            sx={{
              height: 40,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              fontSize: 13,
              borderColor: "#e2e8f0",
              color: "#475569",
              "&:hover": { borderColor: "#2563eb", color: "#2563eb" },
            }}
          >
            Excel
          </Button>
        </Stack>
      </Box>

      {/* Card list */}
      <Box px={2} mt={2} display="flex" flexDirection="column" gap={1.5}>
        {isLoading ? (
          <Box
            width="100%"
            minHeight={200}
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            gap={2}
          >
            <CircularProgress size={36} thickness={4} />
            <Typography fontSize="0.8rem" color={colorSubText}>
              Carregando anúncios...
            </Typography>
          </Box>
        ) : anuncios.length > 0 ? (
          anunciosPaginados.map((row, index) => (
            <MobileAnuncioCard
              key={`${row.id_anuncio}/${index}`}
              row={row}
              navigate={navigate}
              onOpenBuyerDialog={onOpenBuyerDialog}
              onOpenAcessoDialog={onOpenAcessoDialog}
              onOpenCotacaoDialog={onOpenCotacaoDialog}
            />
          ))
        ) : (
          <Box
            width="100%"
            minHeight={160}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Typography fontSize="0.85rem" color={colorSubText}>
              Nenhum anúncio encontrado.
            </Typography>
          </Box>
        )}
      </Box>

      {/* Pagination */}
      {!isLoading && anuncios.length > rowsPerPage && (
        <Box
          mt={3}
          display="flex"
          justifyContent="center"
          alignItems="center"
          gap={2}
          mb={2}
        >
          <PaginationButton
            disabled={page === 0}
            onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
          >
            <ChevronLeft size={20} />
          </PaginationButton>
          <Box
            sx={{
              minWidth: 42,
              height: 32,
              borderRadius: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 700,
              fontSize: "0.85rem",
              color: "#fff",
              background: theme.palette.primary.main,
            }}
          >
            {page + 1}
          </Box>
          <PaginationButton
            disabled={page >= totalPages - 1}
            onClick={() =>
              setPage((prev) => Math.min(prev + 1, totalPages - 1))
            }
          >
            <ChevronRight size={20} />
          </PaginationButton>
        </Box>
      )}

      {/* FAB — quick actions */}
      <Fab
        color="primary"
        onClick={(e) => setFabAnchor(e.currentTarget)}
        sx={{
          position: "fixed",
          bottom: 24,
          right: 24,
          bgcolor: "#ff9f1c",
          "&:hover": { bgcolor: "#ea580c" },
          zIndex: 1300,
        }}
      >
        <Plus size={26} color="#fff" />
      </Fab>

      <Menu
        anchorEl={fabAnchor}
        open={Boolean(fabAnchor)}
        onClose={() => setFabAnchor(null)}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "bottom", horizontal: "right" }}
        PaperProps={{
          sx: {
            borderRadius: 2,
            minWidth: 200,
            border: "1px solid rgba(40,61,107,0.25)",
            boxShadow: "0 12px 32px rgba(0,0,0,0.18)",
          },
        }}
      >
        <MenuItem
          onClick={() => {
            setFabAnchor(null);
            navigate("/veiculo/novo");
          }}
        >
          <ListItemIcon sx={{ color: "#ff9f1c" }}>
            <DirectionsCarIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Novo Veículo" />
        </MenuItem>
        <MenuItem
          onClick={() => {
            setFabAnchor(null);
            navigate("/anuncios/novo");
          }}
        >
          <ListItemIcon sx={{ color: "#ff9f1c" }}>
            <AddCircleIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Novo Anúncio" />
        </MenuItem>
        <MenuItem
          onClick={() => {
            setFabAnchor(null);
            navigate("/anuncios/novo/combo");
          }}
        >
          <ListItemIcon sx={{ color: "#1f2933" }}>
            <LayersIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Novo Combo" />
        </MenuItem>
      </Menu>
    </Box>
  );
}

/* ------------------------------------------------------------------ */
/*  Mobile anuncio card                                                */
/* ------------------------------------------------------------------ */

function MobileAnuncioCard({
  row,
  navigate,
  onOpenBuyerDialog,
  onOpenAcessoDialog,
  onOpenCotacaoDialog,
}: {
  row: AnuncioApiDTO;
  navigate: ReturnType<typeof useNavigate>;
  onOpenBuyerDialog: (id_revenda: number) => Promise<void>;
  onOpenAcessoDialog: (id_anuncio: number) => Promise<void>;
  onOpenCotacaoDialog: (idAnuncio: number, valor: number, revenda: string, tag_status: string, tag_ativo: string, tipo_anuncio: string) => void;
}) {
  const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

  const veiculoLabel =
    row.veiculos.length > 0
      ? row.veiculos.map((v) => v.veiculo).join(" | ")
      : "Veículo não informado";

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 2.5,
        border: "1px solid rgba(40,61,107,0.18)",
        transition: "box-shadow 0.2s ease",
        "&:hover": { boxShadow: "0 4px 16px rgba(0,0,0,0.08)" },
      }}
    >
      <CardActionArea
        onClick={() => {
          if (row.veiculos.length > 1) {
            navigate(`/anuncios/novo/combo/${row.id_anuncio}`);
          } else {
            navigate(`/anuncios/novo/${row.id_anuncio}`);
          }
        }}
        sx={{ p: 0 }}
      >
        <CardContent sx={{ p: 2, "&:last-child": { pb: 2 } }}>
          {/* Top row: tipo + status + menu */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={1}
          >
            <Box display="flex" alignItems="center" gap={1}>
              {tipoAnuncioChip(
                row.veiculos.length > 1 ? "P" : row.tipo_anuncio
              )}
              {statusChip(row.tag_status)}
            </Box>
            <Box
              onClick={(e) => {
                e.stopPropagation();
                setMenuAnchor(e.currentTarget as HTMLElement);
              }}
              sx={{
                cursor: "pointer",
                p: 0.5,
                borderRadius: 1,
                "&:hover": { bgcolor: "rgba(0,0,0,0.04)" },
              }}
            >
              <MoreVertical size={18} color="#6B7588" />
            </Box>
          </Box>

          {/* Veículo */}
          <Typography
            fontWeight={600}
            fontSize="0.9rem"
            color="black"
            noWrap
          >
            {veiculoLabel}
          </Typography>

          {/* Concessionária */}
          <Typography fontSize="0.75rem" color={colorSubText} noWrap>
            {row.concessionaria}
          </Typography>

          <Divider sx={{ my: 1.2 }} />

          {/* Info grid */}
          <Box
            display="grid"
            gridTemplateColumns="1fr 1fr"
            gap={1}
          >
            <InfoCell
              label="Valor Inicial"
              value={formatCurrencyBRL(row.val_inicial)}
              highlight
            />
            <Box
              onClick={(e) => {
                if (row.maior_oferta != null) {
                  e.stopPropagation();
                  onOpenCotacaoDialog(
                    row.id_anuncio,
                    row.maior_oferta,
                    row.revenda ?? "",
                    row.tag_status,
                    row.tag_ativo,
                    row.tipo_anuncio
                  );
                }
              }}
              sx={row.maior_oferta != null ? { cursor: "pointer" } : undefined}
            >
              <InfoCell
                label="Melhor Oferta"
                value={
                  row.maior_oferta != null
                    ? formatCurrencyBRL(row.maior_oferta)
                    : "-"
                }
                highlight
              />
            </Box>
            <InfoCell
              label="Cadastro"
              value={formatDateFromISOTable(row.data_cadastro) ?? "-"}
            />
            <Box
              onClick={(e) => {
                e.stopPropagation();
                onOpenAcessoDialog(row.id_anuncio);
              }}
              sx={{ cursor: "pointer" }}
            >
              <Typography fontSize="0.65rem" color={colorSubText} fontWeight={500}>
                Views
              </Typography>
              <Box display="flex" alignItems="center" gap={0.5}>
                <Eye size={12} color={colorPrimary} />
                <Typography
                  fontSize="0.82rem"
                  fontWeight={600}
                  color={colorPrimary}
                  sx={{ "&:hover": { textDecoration: "underline" } }}
                >
                  {String(row.qtd_total_click ?? 0)}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Melhor oferta — revenda */}
          {row.revenda && (
            <Typography
              fontSize="0.7rem"
              color={colorPrimary}
              fontWeight={600}
              mt={0.8}
              noWrap
              sx={{ cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
              onClick={(e) => {
                e.stopPropagation();
                onOpenBuyerDialog(Number(row.revenda_maior_oferta ?? 0));
              }}
            >
              Oferta de: {row.revenda}
            </Typography>
          )}
        </CardContent>
      </CardActionArea>

      {/* Actions menu */}
      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            borderRadius: 2,
            minWidth: 180,
            border: "1px solid rgba(40,61,107,0.25)",
            boxShadow: "0 12px 32px rgba(0,0,0,0.15)",
          },
        }}
      >
        <MenuItem
          onClick={() => {
            setMenuAnchor(null);
            navigate(`/anuncio/historico/${row.id_anuncio}`);
          }}
        >
          <ListItemIcon sx={{ minWidth: 32, color: "#6B7588" }}>
            <Clock size={16} />
          </ListItemIcon>
          <ListItemText
            primary="Histórico"
            primaryTypographyProps={{ fontSize: "0.85rem" }}
          />
        </MenuItem>
        <MenuItem
          onClick={() => {
            setMenuAnchor(null);
            if (row.tipo_anuncio === "P" || row.veiculos.length > 1) {
              navigate(`/anuncios/detalhe/combo/${row.id_anuncio}`);
            } else {
              navigate(`/anuncios/detalhe/${row.id_anuncio}`);
            }
          }}
        >
          <ListItemIcon sx={{ minWidth: 32, color: "#06c270" }}>
            <Eye size={16} />
          </ListItemIcon>
          <ListItemText
            primary="Visualizar"
            primaryTypographyProps={{ fontSize: "0.85rem" }}
          />
        </MenuItem>
        <MenuItem
          onClick={() => {
            setMenuAnchor(null);
            if (row.veiculos.length > 1) {
              navigate(`/anuncios/novo/combo/${row.id_anuncio}`);
            } else {
              navigate(`/anuncios/novo/${row.id_anuncio}`);
            }
          }}
        >
          <ListItemIcon sx={{ minWidth: 32, color: colorPrimary }}>
            <Pencil size={16} />
          </ListItemIcon>
          <ListItemText
            primary="Editar"
            primaryTypographyProps={{ fontSize: "0.85rem" }}
          />
        </MenuItem>
      </Menu>
    </Card>
  );
}

/* ------------------------------------------------------------------ */
/*  Helper: small label + value pair for mobile cards                  */
/* ------------------------------------------------------------------ */

function InfoCell({
  label,
  value,
  highlight,
}: {
  label: string;
  value: string;
  highlight?: boolean;
}) {
  return (
    <Box>
      <Typography fontSize="0.65rem" color={colorSubText} fontWeight={500}>
        {label}
      </Typography>
      <Typography
        fontSize="0.82rem"
        fontWeight={highlight ? 600 : 400}
        color={highlight ? colorPrimary : "black"}
      >
        {value}
      </Typography>
    </Box>
  );
}
